<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

            <!-- <div class="btn_menu_contextual" @click="set_modulo('busqueda')">
                Búsqueda
            </div> -->


        </div>

        <div class="contenido_">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Control de depósitos
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <b-tabs content-class="mt-3" fill>
                            <b-tab v-if="permisos['depositos.registros']?.ver || ES_ROOT" title="Registro depósitos"
                                active @click="set_modulo('registro_depositos')"></b-tab>
                            <b-tab v-if="permisos['depositos.consulta']?.ver || ES_ROOT" title="Consulta"
                                @click="set_modulo('consulta')"></b-tab>
                        </b-tabs>
                    </div>
                </b-row>

                <RegistroDepositos
                    v-if="modulo == 'registro_depositos' && permisos['depositos.registros']?.ver || ES_ROOT" />
                <Consulta v-if="modulo == 'consulta' && permisos['depositos.consulta']?.ver || ES_ROOT" />


            </b-container>
        </div>
        <!-- <Busqueda v-if="modulo == 'busqueda'" /> -->

    </div>
</template>

<script>
    import RegistroDepositos from './RegistroDepositos.vue';
    import Consulta from './Consulta.vue';
    import { mapGetters, mapState } from 'vuex';
    export default {
        name: 'Descuentos',
        components: {
            RegistroDepositos,
            Consulta
        },
        computed: {
            ...mapState(['permisos']),
            ...mapGetters(['ES_ROOT'])
        },
        data() {
            return {
                modulo: 'registro_depositos',
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo;
            }
        },
    }
</script>

<style></style>